import { apiFetch } from './client';

export async function getUploadUrl(params: {
  bucket: string;
  path: string;
  contentType: string;
}): Promise<{ key: string; url: string; fields?: Record<string, string> }> {
  return apiFetch('/files/upload-url', {
    method: 'POST',
    body: JSON.stringify({
      prefix: params.bucket,
      filename: params.path,
      contentType: params.contentType,
    }),
  });
}

export async function getDownloadUrl(params: {
  bucket: string;
  path: string;
}): Promise<{ url: string }> {
  const key = `${params.bucket}/${params.path}`;
  return apiFetch(`/files/download-url?key=${encodeURIComponent(key)}`);
}

export async function uploadFile(
  bucket: string,
  path: string,
  file: File,
): Promise<{ key: string }> {
  const { key, url } = await getUploadUrl({
    bucket,
    path,
    contentType: file.type,
  });

  const uploadResponse = await fetch(url, {
    method: 'PUT',
    headers: { 'Content-Type': file.type },
    body: file,
  });
  if (!uploadResponse.ok) {
    throw new Error(`Upload failed: ${uploadResponse.status}`);
  }

  return { key };
}

export async function downloadFile(
  bucket: string,
  path: string,
): Promise<Blob> {
  const { url } = await getDownloadUrl({ bucket, path });
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Download failed: ${response.status}`);
  return response.blob();
}

export async function downloadFileByKey(key: string): Promise<Blob> {
  const { url } = await apiFetch<{ url: string }>(`/files/download-url?key=${encodeURIComponent(key)}`);
  const response = await fetch(url);
  if (!response.ok) throw new Error(`Download failed: ${response.status}`);
  return response.blob();
}

export async function deleteFile(key: string): Promise<void> {
  await apiFetch(`/files/delete?key=${encodeURIComponent(key)}`, {
    method: 'DELETE',
  });
}

export async function getFileById(fileId: string): Promise<any> {
  return apiFetch(`/resource/submission_thread/${fileId}`);
}
